export default "/images/vendor/flag-icons/flags/4x3/gl.svg?633d308e7df9c5abcb8919eb401333e7";